<template>
    <div v-if="adminInfo">
        <el-card class="box-card" style="width: 400px">
            <div slot="header" class="clearfix">
                <span>{{adminInfo.name}}</span>
            </div>
            <div>
                <div style="display: flex;justify-content: center">
                    <el-upload
                            :show-file-list="false"
                            :on-success="onSuccess"
                            :data="adminInfo"
                            :headers="myheaders"
                            :action="uploadUrl">
                        <img title="点击修改用户图像" :src="adminInfo.faceUrl" style="width: 100px;height: 100px;border-radius: 50px"
                             alt="">
                    </el-upload>
                </div>
                <div>真实名称：
                    <el-tag>{{adminInfo.adminTrueName}}</el-tag>
                </div>
                <div>用户名：
                    <el-tag>{{adminInfo.adminUserName}}</el-tag>
                </div>
                <div>标签：
                    <el-tag>{{adminInfo.ident}}</el-tag>
                </div>
                 <div>备注：
                    <el-tag>{{adminInfo.remark}}</el-tag>
                </div>
                <div>用户角色：
                    <el-tag type="success" style="margin-right: 5px" v-for="(r,index) in adminInfo.roles" :key="index">
                        {{r.roleRemark}}
                    </el-tag>
                </div>
                <div style="display: flex;justify-content: space-around;margin-top: 10px">
                    <el-button type="primary" @click="showUpdateHrInfoView">修改信息</el-button>
                    <el-button type="danger" @click="showUpdatePasswdView">修改密码</el-button>
                </div>
            </div>
        </el-card>
        <el-dialog
                title="修改用户信息"
                :visible.sync="dialogVisible"
                width="30%">
            <div>
                <table>
                    <tr>
                        <td>
                            <el-tag>真实名称：</el-tag>
                        </td>
                        <td>
                            <el-input v-model="adminInfo2.adminTrueName"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-tag>用户名：</el-tag>
                        </td>
                        <td>
                            <el-input v-model="adminInfo2.adminUserName"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-tag>标签：</el-tag>
                        </td>
                        <td>
                            <el-input v-model="adminInfo2.ident"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-tag>备注：</el-tag>
                        </td>
                        <td>
                            <el-input v-model="adminInfo2.remark"></el-input>
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="updateHrInfo">确 定</el-button>
  </span>
        </el-dialog>
        <el-dialog
                title="修改密码"
                :visible.sync="passwdDialogVisible"
                width="30%">
            <div>
                <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
                         class="demo-ruleForm">
                    <el-form-item label="请输入旧密码" prop="oldpass">
                        <el-input type="password" v-model="ruleForm.oldpass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="请输入新密码" prop="adminPassword">
                        <el-input type="password" v-model="ruleForm.adminPassword" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item label="新确认密码" prop="checkPass">
                        <el-input type="password" v-model="ruleForm.checkPass" autocomplete="off"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                        <el-button @click="resetForm('ruleForm')">重置</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    export default {
        name: "AdminInfo",
        data() {
            var validatePass = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请输入密码'));
                } else {
                    if (this.ruleForm.checkPass !== '') {
                        this.$refs.ruleForm.validateField('checkPass');
                    }
                    callback();
                }
            };
            var validatePass2 = (rule, value, callback) => {
                if (value === '') {
                    callback(new Error('请再次输入密码'));
                } else if (value !== this.ruleForm.adminPassword) {
                    callback(new Error('两次输入密码不一致!'));
                } else {
                    callback();
                }
            };
            return {
                ruleForm: {
                    oldpass: '',
                    adminPassword: '',
                    checkPass: ''
                },
                rules: {
                    oldpass: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    adminPassword: [
                        {validator: validatePass, trigger: 'blur'}
                    ],
                    checkPass: [
                        {validator: validatePass2, trigger: 'blur'}
                    ]
                },
                adminInfo: null,
                uploadUrl:this.getBase()+"/upload/file_pic",
                myheaders:{Authorization:window.sessionStorage.getItem("token")},
                adminInfo2: null,
                dialogVisible: false,
                passwdDialogVisible: false
            }
        },
        mounted() {
            this.initHr();
        },
        methods: {
            onSuccess(response, file, fileList) {

                this.adminInfo2.faceUrl = response.data.downloadPath;
                this.updateHrInfo();
                this.initHr();
            },
            updateHrInfo() {
              
                this.postRequest("/admin/register", this.adminInfo2).then(resp => {
                    if (resp) {
                        this.dialogVisible = false;
                        this.initHr();
                    }
                })
            },
            showUpdateHrInfoView() {
                this.dialogVisible = true;
            },
            submitForm(formName) {
                this.$refs[formName].validate((valid) => {
                    if (valid) {
                        this.ruleForm.hrid = this.adminInfo.id;
                        this.postRequest("/admin/edit_password", this.ruleForm).then(resp => {
                            if (resp) {
                                this.postRequest("/admin/logout");
                                window.sessionStorage.removeItem("user")
                                this.$store.commit('initRoutes', []);
                                this.$router.replace("/");
                            }
                        })
                    } else {
                        return false;
                    }
                });
            },
            resetForm(formName) {
                this.$refs[formName].resetFields();
            },
            showUpdatePasswdView() {
                this.passwdDialogVisible = true;
            },
            initHr() {
                this.postRequest('/admin/info').then(resp => {
                    if (resp) {
                        this.adminInfo = resp.data;
                        this.adminInfo2 = Object.assign({}, this.adminInfo);
                        window.sessionStorage.setItem("user", JSON.stringify(resp.data));
                        this.$store.commit('INIT_CURRENTHR', resp.data);
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>